/* eslint-disable complexity */
import React, { useState, useEffect } from 'react'
import { Message, injectWorldReady } from '@paypalcorp/worldready-react'
import OnboardingBanner from '../../../pages/home/sections/onboarding-banner'
import OutdatedAppsBanner from '../../upgrade-hub/outdated-app-banner'
import { useApplicationContext } from '../../../context/ApplicationContext'
import axios from '../../../utils/axios-util'
import { getUserType } from '../../../utils/user-utils'
import {
  CaptionText,
  Col,
  Container,
  HeadingText,
  LoadingSpinner,
  Row,
} from '@paypalcorp/pp-react'
import AppSwitcher from '../../../pages/applications/sections/app-switcher'
import DateRangeSelect from '../../../pages/applications/sections/date-range-select'
import SummaryBadge from '../../../pages/home/sections/summary-badge'
import SellerInvitation from '../../../pages/home/sections/seller-invitation'
import { loadUserPreferences } from '../../../helper/user-helper'
import Spinner from '../../common/spinner'
import AnalyticsProvider from '../../upgrade-hub/analytics/analytics-context'
import useOutdatedAppsBanner from '../../upgrade-hub/hooks/use-outdated-apps-banner'
import { NEW_USER } from '../../../constants'

// eslint-disable-next-line complexity
function PreArticle() {
  const {
    isAppsDataListLoading,
    csrf,
    setCurrentBannerStep,
    setUserPreferences,
    enviroment,
    errorSummaryCount,
    failedTransactions,
    user,
    banner,
    isBannerHidden,
    isConfirmedEmail,
    hasApprovalRequest,
    approvalRequestInfo,
    createTestAccount,
  } = useApplicationContext()
  const accountType = getUserType(user)

  const [isOnboardingBannerClosed, setIsOnboardingBannerClosed] = useState(true)
  const [isTransactionBadgeClosed, setIsTransactionBadgeClosed] = useState(true)
  const [isErrorSummaryBadgeClosed, setIsErrorSummaryBadgeClosed] = useState(
    true,
  )

  const [hasUpgrade, setHasUpgrade] = useState(false)

  const [bannerPage, setBannerPage] = useState(0)
  const [productIntegration, setProductIntegration] = useState('')
  const [isBannerInfoLoaded, setIsBannerInfoLoaded] = useState(false)
  const [isUserPreferenceLoaded, setIsUserPreferenceLoaded] = useState(false)
  const [isSavingUserPreferences, setIsSavingUserPreferences] = useState(false)
  const {
    hasOutdatedApps,
    outdatedApps,
    isOutdatedAppsLoading,
    outdatedAppsError,
    closeOutdatedAppsBanner,
  } = useOutdatedAppsBanner()

  const BANNER_PREFERENCE_NAME = 'ONBOARDING_BANNER'
  const BANNER_PREFERENCE_VALUE = 'CLOSED'

  const getBannerProgress = () => {
    const applicationJSON = 'application/json';
    axios({
      method: 'get',
      url: '/dashboard/bannerProgress',
      headers: {
        Accept: applicationJSON,
        'Content-Type': applicationJSON,
        'x-csrf-token': csrf,
      },
      responseType: 'json',
      contentType: applicationJSON,
    }).then(({ data }) => {
      setBannerPage(data?.bannerProgress || 0)
      setProductIntegration(data?.productIntegration || 'stdCheckout')
      setIsTransactionBadgeClosed(data?.closeTransactionBanner)
      setIsErrorSummaryBadgeClosed(data?.closeErrorSummaryBanner)
      setIsBannerInfoLoaded(true)
      const sessionObject = {
        bannerPage: data?.bannerProgress || 0,
        closeOnboardingBanner: data?.closeOnboardingBanner || false,
      }
      setCurrentBannerStep(sessionObject)
    })
  }

  const getUserPreferences = async () => {
    const preferences = await loadUserPreferences()
    setUserPreferences(preferences)

    const userBannerPreference = preferences.find(
      (userPreference) => userPreference.devup_name === BANNER_PREFERENCE_NAME,
    )

    if (userBannerPreference) {
      setIsOnboardingBannerClosed(
        userBannerPreference.devup_value === BANNER_PREFERENCE_VALUE,
      )
    } else {
      setIsOnboardingBannerClosed(false)
    }
    setIsUserPreferenceLoaded(true)
  }

  const upgradeAccountRequired = async () => {
    if (accountType === 'IDENTITY') {
      setHasUpgrade(true)
    } else {
      setHasUpgrade(false)
    }
  }

  useEffect(() => {
    getBannerProgress()
    getUserPreferences()
    upgradeAccountRequired()
  }, [])

  const titleMessage = <Message id="onboarding-banner.prearticle.title" />
  const welcomeBackTitle = (
    <Message id="onboarding-banner.prearticle.welcomebacktitle" />
  )
  let subtitleMessage

  if (!isOutdatedAppsLoading) {
    if (outdatedAppsError || hasOutdatedApps) {
      subtitleMessage = <Message id="upgrade-hub.subtitle" />
    } else if (
      !isOnboardingBannerClosed &&
      !isAppsDataListLoading &&
      isBannerInfoLoaded &&
      isUserPreferenceLoaded
    ) {
      subtitleMessage = <Message id="onboarding-banner.prearticle.subtitle" />
    }
  }

  return (
    <div
      className={
        banner.isActive === 'on' && !isBannerHidden
          ? 'dev_dash__page--pre-article__wrapper_banner'
          : 'dev_dash__page--pre-article__wrapper'
      }
    >
      {!user.unauthorized === true && (
        <div className="dev_dash__page--pre-article__content--container">
          {isSavingUserPreferences && <Spinner fullScreen={true} size="xl" />}
          <Container
            xxl={true}
            data-testid="dashboard-home-page__prearticle"
            className="dashboard_home__prearticle"
          >
            <div>
              <Row>
                <Col md={7}>
                  <HeadingText className="caption-article">
                    {createTestAccount === NEW_USER
                      ? titleMessage
                      : welcomeBackTitle}
                  </HeadingText>
                  <CaptionText className="caption-prearticle">
                    {subtitleMessage}
                  </CaptionText>
                </Col>
                <Col md={3}>
                  <AppSwitcher />
                </Col>
                <Col md={2}>
                  <DateRangeSelect />
                </Col>
              </Row>
            </div>
            <br />
            {hasApprovalRequest || !isConfirmedEmail || hasUpgrade === false ? (
              <div>
                <SellerInvitation
                  approvalRequestInfo={approvalRequestInfo}
                  hasApprovalRequest={hasApprovalRequest}
                  hasUpgrade={hasUpgrade}
                />
              </div>
            ) : null}

            <Row>
              <Col>
                <div className="summary_badge-container">
                  {/* show Summaries based on (1) enviroment, (2) Onboarding banner is closed, and (3) Badge not aleady dismissed */}
                  {!hasOutdatedApps &&
                    isOnboardingBannerClosed &&
                    !isErrorSummaryBadgeClosed && (
                      <SummaryBadge
                        type="error-log"
                        closeBadge={setIsErrorSummaryBadgeClosed}
                        linkFullPage={`errors/${enviroment}`}
                        count={errorSummaryCount}
                      />
                    )}
                  {enviroment === 'live' &&
                    !hasOutdatedApps &&
                    isOnboardingBannerClosed &&
                    !isTransactionBadgeClosed && (
                      <SummaryBadge
                        type="recent-transactions"
                        closeBadge={setIsTransactionBadgeClosed}
                        linkFullPage=""
                        count={failedTransactions.length}
                      />
                    )}
                </div>
              </Col>
            </Row>

            <br />
            {isOutdatedAppsLoading && (
              <LoadingSpinner screenReaderText="loading" />
            )}
            {!isOutdatedAppsLoading && (outdatedAppsError || hasOutdatedApps) && (
              <div className="section-oudated-apps-banner">
                <AnalyticsProvider>
                  <OutdatedAppsBanner
                    hasOutdatedApps={hasOutdatedApps}
                    outdatedApps={outdatedApps}
                    isOutdatedAppsLoading={isOutdatedAppsLoading}
                    outdatedAppsError={outdatedAppsError}
                    closeOutdatedAppsBanner={closeOutdatedAppsBanner}
                  />
                </AnalyticsProvider>
              </div>
            )}
            {!isOutdatedAppsLoading && !hasOutdatedApps && (
              <div className="section-onboarding_banner">
                {!isOnboardingBannerClosed &&
                  !isAppsDataListLoading &&
                  isBannerInfoLoaded &&
                  isUserPreferenceLoaded && (
                    <OnboardingBanner
                      closeBanner={setIsOnboardingBannerClosed}
                      bannerPage={bannerPage}
                      setBannerPage={setBannerPage}
                      productIntegration={productIntegration}
                      setProductIntegration={setProductIntegration}
                      setIsSavingUserPreferences={setIsSavingUserPreferences}
                    />
                  )}
              </div>
            )}
          </Container>
        </div>
      )}
    </div>
  )
}

export default injectWorldReady(PreArticle)
